import { create } from "zustand";
import type { EmailCopy, EmailTemplate } from "./api";
export type TemplateDraft = { baseline: EmailTemplate; values: EmailCopy; needsRevert: boolean };
type DraftStore = { actorId: string | null; drafts: Record<string, TemplateDraft>; retain: (actorId: string, key: string, draft: TemplateDraft) => void; activate: (actorId: string) => void; clear: () => void };
// Memory only; retain through an access recheck, clear on explicit sign-out/account change.
export const useEmailDrafts = create<DraftStore>(set => ({ actorId: null, drafts: {},
  retain: (actorId, key, draft) => set(state => ({ actorId, drafts: { ...(state.actorId === actorId ? state.drafts : {}), [key]: draft } })),
  activate: actorId => set(state => state.actorId === actorId ? state : { actorId, drafts: {} }),
  clear: () => set({ actorId: null, drafts: {} }),
}));
